import { createSlice } from '@reduxjs/toolkit'

import * as reducers from './reducers'

const dbSlice = createSlice({
  name: 'db',
  initialState: {},
  reducers
})

export default dbSlice
